import React from "react";
import { useTranslation } from "react-i18next";
import { CircleHelp } from "lucide-react";
export default function SessionEndedModal({
  isOpen,
  title,
  message,
  subMessage,
  buttonText,
  onClose,
}) {
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <div className="shake-sheet-overlay" onClick={onClose}>
      <div
        className="shake-reward-sheet"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="shake-state-title"
      >
        <div className="shake-modal-icon">
          <CircleHelp size={30} aria-hidden="true" />
        </div>
        <h2 id="shake-state-title">{title ?? t("sessionEnded.title")}</h2>
        <p>
          {message ?? t("sessionEnded.message")}
          {(subMessage ?? t("sessionEnded.subMessage")) && (
            <>
              <br />
              {subMessage ?? t("sessionEnded.subMessage")}
            </>
          )}
        </p>
        <button className="shake-game-button" onClick={onClose}>
          {buttonText ?? t("common.done")}
        </button>
      </div>
    </div>
  );
}
